/**
 * @param {ErrorResponse} errorResponse
 *
 * @returns {?string}
 */
export default (function (errorResponse) {
  var _ref = errorResponse.getData() || {},
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? null : _ref$error,
      _ref$messages = _ref.messages,
      messages = _ref$messages === void 0 ? [] : _ref$messages;

  if (errorResponse.getStatus() === 503 && error === 'maintenance' && Array.isArray(messages) && messages.length > 0) {
    // TODO: may be more than one message in theory...
    return messages[0];
  }

  return null;
});